import { Helmet } from "react-helmet";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import logo from "../img/oglitzWithe.png";
import "./UpdatedFooter.css";

const schemaData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Oglitz Software Pvt Ltd.",
  url: "https://www.oglitz.com",
  logo: "https://www.oglitz.com/logo.png",
  sameAs: [
    "https://www.facebook.com/profile.php?id=61565024655930",
    "https://www.linkedin.com/company/oglitz/",
    "https://x.com/OglitzSoftware",
    "https://www.instagram.com/oglitzsoftware",
  ],
};

const UpdatedFooter = () => {
  return (
    <>
      <div className="uiq-section-divider"></div>
      <footer className="uiq-footer">
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(schemaData)}
          </script>
        </Helmet>

        {/* ===== GLASS BACKGROUND WRAPPER ===== */}
        <div className="uiq-footer-glass">
          <div className="uiq-footer-content">
            {/* BRAND */}
            <div className="uiq-footer-section">
              <img
                src={logo}
                alt="Oglitz Software"
                className="uiq-footer-logo"
              />
              <p className="uiq-footer-desc">
                Global custom software development company delivering premium
                web, mobile, cloud, and enterprise solutions.
              </p>

              <div className="uiq-social-wrap">
                <a
                  href="https://www.facebook.com/profile.php?id=61565024655930"
                  className="uiq-social-icon"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.linkedin.com/company/oglitz/"
                  className="uiq-social-icon"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://x.com/OglitzSoftware"
                  className="uiq-social-icon"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://www.instagram.com/oglitzsoftware"
                  className="uiq-social-icon"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>

            {/* MENU */}
            <div className="uiq-footer-section">
              <h4 className="uiq-footer-section-title">Menu</h4>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About Us</a>
                </li>
                <li>
                  <a href="/project">Projects</a>
                </li>
                <li>
                  <a href="/design">Design Pack</a>
                </li>
                <li>
                  <a href="/plans-pricing">Plans & Pricing</a>
                </li>
                <li>
                  <a href="/contact">Contact Us</a>
                </li>
                <li>
                  <a href="/terms-and-conditions">Terms And Conditions</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
              </ul>
            </div>

            {/* SERVICES (SHORT) */}
            <div className="uiq-footer-section">
              <h4 className="uiq-footer-section-title">Services</h4>

              <ul>
                <li>
                  <a href="/start-project">Custom Software Development</a>
                </li>
                <li>
                  <a href="/start-project">Web & Mobile Applications</a>
                </li>
                <li>
                  <a href="/start-project">Cloud Solutions</a>
                </li>
                <li>
                  <a href="/start-project">UI / UX Design</a>
                </li>
                <li>
                  <a href="/start-project">E-Commerce Solutions</a>
                </li>

                <li className="uiq-footer-more">
                  <a href="/services-technologie">View All Services →</a>
                </li>
              </ul>
            </div>

            {/* TECHNOLOGIES (SHORT) */}
            <div className="uiq-footer-section">
              <h4 className="uiq-footer-section-title">Technologies</h4>
              <ul>
                <li>React / React Native</li>
                <li>Node.js / PHP</li>
                <li>Python & AI/ML</li>
                <li>Flutter</li>
                <li className="uiq-footer-more">
                  <a href="/services-technologies">More Technologies →</a>
                </li>
              </ul>
            </div>

            <div className="uiq-footer-row">
              {/* LOCATIONS */}
              <div className="uiq-footer-section uiq-footer-locations">
                <h4 className="uiq-footer-section-title">Our Locations</h4>

                <div className="uiq-location-card">
                  <strong>India</strong>
                  <p>
                    <FaMapMarkerAlt /> Kanpur Nagar, Uttar Pradesh – 208007
                  </p>
                  <p>
                    <FaEnvelope /> info@oglitz.com
                  </p>
                  <p>
                    <FaPhoneAlt /> +91 95321 19007
                  </p>
                </div>

                <div className="uiq-location-card">
                  <strong>United Arab Emirates</strong>
                  <p>
                    <FaMapMarkerAlt /> Dubai, UAE
                  </p>
                  <p>
                    <FaEnvelope /> info@oglitz.com
                  </p>
                  <p>
                    <FaPhoneAlt /> +971 56 872 9406
                  </p>
                </div>
              </div>

              {/* WHATSAPP CTA */}
              <div className="uiq-footer-section uiq-footer-whatsapp">
                <h4 className="uiq-footer-section-title">WhatsApp Us</h4>

                <a
                  href="https://wa.me/919532119007"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="uiq-whatsapp-btn"
                >
                  <FaWhatsapp /> WhatsApp India
                </a>

                <a
                  href="https://wa.me/+971568729406"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="uiq-whatsapp-btn dubai"
                >
                  <FaWhatsapp /> WhatsApp UAE
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="uiq-footer-divider"></div>

        <div className="uiq-footer-bottom">
          © {new Date().getFullYear()} Oglitz Software Pvt Ltd. All rights
          reserved.
        </div>
      </footer>
    </>
  );
};

export default UpdatedFooter;
